import $ from 'jquery';

export default class OrderProductTypeSelect {
  static init() {
    const $orderProductType = $('.js__order-product-type-toggle');

    $orderProductType.on('change', e => {
      const $item = $(e.currentTarget).dropdown('get item');
      if (!$item) {
        return;
      }
      const bundleVariantsUrl = $item.data('bundle');
      if (typeof bundleVariantsUrl !== 'undefined') {
        $.get(bundleVariantsUrl)
          .fail(() => console.log('error'))
          .done(result => {
            $item.closest('li').find('.js__order-product-type-target').replaceWith(result);
            $item.closest('li').find('.js__order-product-type-target').find('input').trigger('change');
            $item
              .closest('li')
              .find('.js__order-product-type-target')
              .find('.search-select')
              .dropdown({ fullTextSearch: true });
          })
          .always(() => $orderProductType.removeClass('disabled loading'));
      } else {
        $item.closest('li').find('.js__order-product-type-target').empty();
      }
    });
  }
}
